import { render, staticRenderFns } from "./ScreeningLabelComponent.vue?vue&type=template&id=e06e10ce&scoped=true&"
import script from "./ScreeningLabelComponent.vue?vue&type=script&lang=js&"
export * from "./ScreeningLabelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e10ce",
  null
  
)

export default component.exports